import React from 'react';
import { AcceptedProps } from '../interface/accepted-props';
import SignatureType from '../type/file/signature';

const Signature: React.FC<AcceptedProps> = (props) => {
  return <SignatureType {...props} />
}

export default Signature;